import Vue from 'vue';
import { gsap } from 'gsap';
import { values } from 'lodash';

Vue.component('dropdown-component', {
    props: {
        values: {
            type: Array,
        },
        setInitialValue: {
            type: Boolean,
            default: false,
        },

        initialValue: {
            required: false,
        },
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            // subjects: null,
            selectedValue: null,
            selectIsOpen: false,
            isAnimating: false,
            dropdownList: null,
            dropdownArrow: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        if (!this.values.length) {
            return;
        }

        // Set first subject as default
        this.selectedValue = this.values[0];
        if (this.initialValue) {
            this.selectedValue = this.initialValue;
        }

        if (this.setInitialValue) {
            this.$emit('on-value-select', this.selectedValue);
        }

        this.dropdownList = this.$el.querySelector('.dropdown-list');
        this.dropdownArrow = this.$el.querySelector('.dropdown-arrow');
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        toggleSelect() {
            if (this.isAnimating) {
                return;
            }

            this.isAnimating = true;

            if (this.selectIsOpen) {
                this.closeSelect();
                return;
            }

            this.openSelect();
        },

        openSelect() {
            const tl = gsap.timeline();

            tl
            .set(this.dropdownList, {
                borderBottom: '1px solid #DDD7D0',
            })
            .to(this.dropdownList, 1, {
                height: 'auto',
                ease: 'power4.out',
                onComplete: () => {
                    this.selectIsOpen = true;
                    this.isAnimating = false;
                },
            })
            .to(this.dropdownArrow, 1, {
                rotate: 180,
                ease: 'power4.out',
            }, '<')
            .set(this.dropdownList, {
                overflowY: () => {
                    const items = this.$el.querySelectorAll('.dropdown-item');
                    if ((items.length * items[0].offsetHeight) > 300) {
                        return 'scroll';
                    }
                    return 'hidden';
                },
            });
        },

        closeSelect() {
            const tl = gsap.timeline();
            tl
            .to(this.dropdownList, 1, {
                height: 0,
                ease: 'power4.out',
                onComplete: () => {
                    this.selectIsOpen = false;
                    this.isAnimating = false;
                },
            })
            .to(this.dropdownArrow, 1, {
                rotate: 0,
                ease: 'power4.out',
            }, '<')
            .set(this.dropdownList, {
                borderBottom: 'none',
            });
        },

        selectValue(subject) {
            this.selectedValue = subject;
            this.isAnimating = true;
            this.closeSelect();
            this.$emit('on-value-select', this.selectedValue);
        },
    },
});
